export const SessionDataMap = {
  'cacheData.data.AriesReservation.propertyId': 'propertyId',
  locale: 'locale',
  'cacheData.data.consumerID': 'consumerID',
  'cacheData.data.AriesCommon.memState': 'userState',
  'cacheData.data.AriesCommon.prop_name': 'name',
  'cacheData.data.AriesSearch.searchCriteria.address': 'hotelAddress',
  'cacheData.data.AriesCommon.brndCode': 'brndCode',
  'cacheData.data.AriesReservation.isMax': 'isMax',
};

export const HotelDataMap = {
  'data.catalog.propertyById.basicInformation.brand.id': 'brandCode',
  'data.catalog.propertyById.basicInformation.name': 'hotelName',
  'data.catalog.propertyById.basicInformation.latitude': 'latitude',
  'data.catalog.propertyById.basicInformation.longitude': 'longitude',
  'data.catalog.propertyById.basicInformation.currency': 'currency',
  'data.catalog.propertyById.reviews.numberOfReviews': 'hotelReviews',
  'data.catalog.propertyById.reviews.stars': 'stars',
  'data.catalog.propertyById.contactInformation.address.line1': 'addressLine1',
  'data.catalog.propertyById.contactInformation.address.line2': 'addressLine2',
  'data.catalog.propertyById.contactInformation.address.line3': 'addressLine3',
  'data.catalog.propertyById.contactInformation.address.city': 'city',
  'data.catalog.propertyById.contactInformation.address.stateProvince.description': 'stateProvince',
  'data.catalog.propertyById.contactInformation.address.country.description': 'country',
  'data.catalog.propertyById.contactInformation.address.postalCode': 'postalCode',
  'data.catalog.propertyById.contactInformation.contactNumbers': 'phoneNumbers',
  'data.catalog.propertyById.seoNickname': 'seoNickname',
  'data.customer': 'userData',
  'data.catalog.propertyById.media.primaryImage.edges[0].node.imageUrls.wideHorizontal': 'imageUrl',
  'data.catalog.propertyById.media.hotelLogo.edges[0].node.imageSrc': 'hotelLogoImg',
};

export const UniqueHotelLogoMap = {
  'images[0].imageFile': 'imageUrl',
};
